function BackofficeDefaultHeader() {
  return <></>
}

export { BackofficeDefaultHeader }
